import { createSlice } from "@reduxjs/toolkit";

// Load token and user from localStorage
const initialState = {
  token: localStorage.getItem("token") || null,
  user: JSON.parse(localStorage.getItem("user")) || null,
  RmMgName: localStorage.getItem("RmMgName") || null, // Added RmMgName
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { token, user } = action.payload || {};
      state.token = token || null;
      state.user = user || null;
      
      // Persist in localStorage
      if (token) localStorage.setItem("token", token);
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
        // Store additional fields
        localStorage.setItem("EmpNo", user.EmpNo || "");
        localStorage.setItem("MgCd", user.MgCd || "");
        localStorage.setItem("RmMgName", user.RmMgName || ""); // Added RmMgName
      }
      state.RmMgName = user?.RmMgName || null; // Set RmMgName in state
    },
    
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.RmMgName = null; // Clear RmMgName
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("EmpNo");
      localStorage.removeItem("MgCd");
      localStorage.removeItem("RmMgName"); // Remove RmMgName from storage
    },

    // Add new reducer to update RmMgName separately
    setRmMgName: (state, action) => {
      state.RmMgName = action.payload;
      localStorage.setItem("RmMgName", action.payload);
    }
  },
});

// Export actions and reducer
export const { setUser, logout, setRmMgName } = authSlice.actions;
export default authSlice.reducer;